import { getUserIdFromCookie } from 'utils/auth';

const userId = getUserIdFromCookie();
let customUserAttributes = {
  isOnline: false,
  ...(userId && { userId }),
};

export const setCustomUserAttributesWebengage = attributes => {
  customUserAttributes = { ...customUserAttributes, ...attributes };
};

export const overrides = { mixpanel: true };

export const getClosestDataAttributes = (ele, attr) =>
  ele.closest(`[${attr}]`)?.getAttribute(attr);
